import { render } from "./contactComponent.vue?vue&type=template&id=22dccf9a&scoped=true"
const script = {}

import "./contactComponent.vue?vue&type=style&index=0&id=22dccf9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22dccf9a"]])

export default __exports__